const sizeFilter = (filter, size) => {
  if (!filter || (!filter.from && !filter.to)) return true;
  if (!size) return false;

  return (
    (filter.from <= size.from && size.to <= filter.to && size.unit === filter.unit) ||
    (filter.from <= size.to && !filter.to) ||
    (size.from <= filter.to && !filter.from)
  );
};

export default sizeFilter;
